import { useRef } from 'react';
import type { TextInput } from 'react-native';
import { Icon, Input, type InputProps, SearchIcon, XStack } from 'smoothie';

export const SearchInput = (props: InputProps) => {
    const searchInputRef = useRef<TextInput>(null);

    return (
        <XStack
            width="50%"
            gap={8}
            alignItems="center"
            justifyContent="flex-end"
        >
            <Icon icon={SearchIcon} size={24} />
            <Input
                ref={searchInputRef}
                width="100%"
                padding={16}
                borderRadius={12}
                borderColor="$gray800"
                backgroundColor="$white"
                color="$black"
                fontWeight="regular"
                fontSize="$2"
                blurOnSubmit={false}
                focusVisibleStyle={{
                    outlineWidth: 1,
                }}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus={true}
                // @ts-expect-error typescript isn't confident that e is a KeyboardEvent because the parent type is cross-platform
                onKeyPress={(e: KeyboardEvent) => {
                    if (e.key === 'Escape') {
                        searchInputRef.current?.blur();
                    }
                }}
                {...props}
            />
        </XStack>
    );
};
